<template>
    <BaseModalNew :title="''" @close="closeModal">
        <template #modalContent>
            <div class="m-content-wrapper">
                <div class="m-content-heading">
                    <span>Powered by</span>
                    <DidIcon />
                    <h2>DecastID</h2>
                </div>
                <div class="m-hr"></div>
                <div class="m-subheading-wrapper">
                    <h3 class="m-content-subheading">
                        Choose How You’d Like to Verify
                    </h3>
                    <p>Select your preferred identity provider to start verification.</p>
                </div>
                <div class="m-content-div">
                    <button class="cv-btn" @click="handleDidsLogin">
                        <DidIcon />
                        <span>Did</span>
                    </button>
                    <button class="cv-btn" @click="redirectToService('google-account')">
                        <GoogleLogo />
                        <span>Google</span>
                    </button>
                    <button class="cv-btn" @click="redirectToService('email-verification')">
                        <EmailIcon />
                        <span>Email</span>
                    </button>
                </div>
            </div>
        </template>
    </BaseModalNew>
</template>

<script>
import BaseModalNew from "@/components/common/BaseModalNew.vue";
import GoogleLogin from "@/decast/components/v2auth/social-logins/GoogleLogin.vue";
import DidIcon from "@/decast/icons/DidIcon.vue";
import GoogleLogo from '@/decast/icons/GoogleLogo.vue';
import MetamaskLogo from '@/decast/icons/MetamaskLogo.vue';
import EmailIcon from "@/decast/icons/EmailIcon.vue";
import constants from '../../../../constant';

const EXTENSION_ID = constants.didManagerExtensionKey;

export default {
    name: 'ChooseVerifierModal',
    props: ['closeModal'],
    components: {
        BaseModalNew,
        GoogleLogin,
        DidIcon,
        GoogleLogo,
        MetamaskLogo,
        EmailIcon,
    },
    data() {
        //     const currentDate = new Date().toISOString();
        // console.log(currentDate);
        return {
            services: {
                "google-account": {
                    service: "google-account",
                    subjects: ["firstName", "lastName", "email"],
                    conditions: [
                        {
                            subject: "updatedAt",
                            condition: "gt",
                            value: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
                        }
                    ],
                    callback_url: `${this.$globals.clientDomain}/did-callback`
                },
                "email-verification": {
                    service: "email-verification",
                    subjects: ["email"],
                    conditions: [
                        {
                            subject: "updatedAt",
                            condition: "gt",
                            value: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
                        }
                    ],
                    callback_url: `${this.$globals.clientDomain}/did-callback`
                },
                // "email-verification": {
                //     service: "email-verification",
                //     subjects: ["firstName", "lastName", "email"],
                //     conditions: [
                //         {
                //             subject: "updatedAt",
                //             condition: "gt",
                //             value: "2025-08-08T14:57:20.322Z"
                //         }
                //     ],
                //     callback_url: `${this.$globals.clientDomain}/did-callback`
                // },
                // you can add more services here...
            },
        };
    },
    mounted() {
        window.addEventListener('message', this.handleDidSelected);
    },
    beforeUnmount() {
        window.removeEventListener('message', this.handleDidSelected);
    },
    methods: {
        redirectToService(serviceName) {
            const service = this.services[serviceName]
            if (!service) {
                console.error("Service not found:", serviceName)
                return
            }

            // Convert object to query string
            const query = new URLSearchParams({
                service: service.service,
                subjects: JSON.stringify(service.subjects),
                conditions: JSON.stringify(service.conditions),
                callback_url: service.callback_url
            }).toString()
            window.open(`${this.$globals.widBaseUrl}/verify?${query}`, "_blank")
        },
        async handleDidsLogin() {
            this.isLoading = true;
            this.errorMessage = '';

            if (window.chrome && chrome.runtime) {
                chrome.runtime.sendMessage(
                    EXTENSION_ID,
                    { action: 'open-did-popup' },
                    (response) => {
                        if (chrome.runtime.lastError) {
                            this.isLoading = false;
                            this.errorMessage = 'Extension not available';
                        }
                    }
                );

                window.addEventListener('message', this.handleDidSelected);
            } else {
                this.isLoading = false;
                this.errorMessage = 'Extension API not available';
                // this.$vs.notify({
                //   title: 'Request Unsuccessful',
                //   text: 'Extension not installed or not available',
                //   iconPack: 'feather',
                //   icon: 'icon-check-circle',
                //   color: 'danger',
                // });
                window.location.href = 'https://chrome.google.com/webstore/detail/decast-did-manager/' + EXTENSION_ID;
                return;
            }
        },
        async handleDidSelected(event) {
            if (event.data?.action !== 'did-selected') return;

            window.removeEventListener('message', this.handleDidSelected);

            try {
                const { did } = event.data;
                this.selectedDid = typeof did === 'string' ? did : did?.did || '';
                console.log("[Decast] DID selected:", did);

                const payload = did
                console.log("[Decast] Dispatching v2getDidNonce with payload:", payload);
                this.$store
                    .dispatch('auth/v2getDidNonce', payload)
                    .then((response) => {
                        const { nonce, token } = response.data;

                        console.log("[Decast] Nonce received from API:", nonce);
                        chrome.runtime.sendMessage(
                            EXTENSION_ID,
                            { action: "sign-nonce", nonce, did },
                            (response) => {
                                if (chrome.runtime.lastError) {
                                    this.errorMessage = 'Error communicating with extension';
                                } else {
                                    // this.$vs.notify({
                                    //   title: 'Success',
                                    //   text: 'Nonce sent to extension for signing',
                                    //   iconPack: 'feather',
                                    //   icon: 'icon-check-circle',
                                    //   color: 'success',
                                    // });
                                    // console.log("[Decast] Nonce sent to extension for signing");
                                }
                            }
                        );

                        window.addEventListener('message', (e) => this.handleNonceSigned(e, token));
                    })
                    .catch((error) => {
                        // Safely extract the specific error message
                        const errorResponse = error.response?.data;
                        let message = "An error occurred.";
                        if (errorResponse?.errors?.email) {
                            message = "Account does not exist!";
                        } else if (typeof errorResponse?.errors === 'string') {
                            message = errorResponse.errors;
                        }
                        // this.$vs.notify({
                        //   title: 'Login Failed',
                        //   text: message,
                        //   iconPack: 'feather',
                        //   icon: 'icon-alert-circle',
                        //   color: 'danger',
                        // });
                    }).finally(() => { });
            } catch (err) {
                this.isLoading = false;
                this.errorMessage = err.message;
            }
        },
        async handleNonceSigned(event, token) {
            // console.log("[Decast] Handling nonce signed event");
            // console.log("[Decast] Event data:", event.data, event.data?.action);
            if (event.data?.action !== 'nonce-signed') return;

            window.removeEventListener('message', this.handleNonceSigned);

            if (event.data.error) {
                this.$vs.notify({
                    title: 'Nonce Signing Canceled',
                    text: event.data.error,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'warning',
                });
                this.isLoading = false;
                this.errorMessage = event.data.error;
                return;
            }

            // this.$vs.notify({
            //   title: 'Success',
            //   text: 'Nonce signed successfully',
            //   iconPack: 'feather',
            //   icon: 'icon-check-circle',
            //   color: 'success',
            // });

            const { signature } = event.data;
            console.log("[Decast] Nonce signed by extension:", signature);

            try {
                console.log("[Decast] Preparing DID Document for login");

                const didDocument = {
                    '@context': 'https://www.w3.org/ns/did/v1',
                    id: this.selectedDid,
                    verificationMethod: [{
                        id: `${this.selectedDid}#keys-1`,
                        type: 'Ed25519VerificationKey2018',
                        controller: this.selectedDid,
                        publicKeyBase58: this.selectedDid.split(':').pop(),
                    }],
                    authentication: [`${this.selectedDid}#keys-1`],
                };

                console.log("[Decast] DID Document prepared2:", didDocument);

                const payload = {
                    token,
                    signature,
                    didDocument,
                };
                console.log("[Decast] Dispatching v2loginWithDid with payload:", payload);
                this.$store.dispatch('auth/v2loginWithDid', payload)
                    .then((response) => {
                        console.log("[Decast] Login response:", response.data);
                        const isTwoFactorAuthEnabled = response.data?.twoFactorAuthentication;
                        if (isTwoFactorAuthEnabled) {
                            //ask for 2fa
                            const twoFactorToken = response.data?.token;
                            this.$router.push({ name: 'TwoFactor', query: { tempToken: twoFactorToken } });
                        } else {
                            this.$store.commit('auth/SET_LOGGEDIN', true);
                            this.$acl.change('user');
                            this.$vs.notify({
                                title: 'Login Successful',
                                text: 'Redirecting to dashboard!',
                                iconPack: 'feather',
                                icon: 'icon-check-circle',
                                color: 'success',
                            });
                            this.$router.push('/dashboard/rooms');
                        }
                    })
                    .catch((error) => {

                        console.log(error, 'login error');
                        // this.$vs.notify({
                        //   title: 'Login Failed',
                        //   text: error,
                        //   iconPack: 'feather',
                        //   icon: 'icon-alert-circle',
                        //   color: 'danger',
                        // });
                    }).finally(() => {
                        this.isLoading = false;
                        document.getElementById('loading-bg-transparent').style.display = 'none';
                    });
            } catch (err) {
                this.errorMessage = err.message;
                this.isLoading = false;
            }
        },
    },
}
</script>

<style scoped>
*:not(i) {
    /* font-family: 'Karla', sans-serif !important; */
    font-family: 'Rethink Sans' !important;
}

.m-content-wrapper {
    /* background-color: #1B1D29; */
    border-radius: 20px;
    width: 550px;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: 90vh;
    /* overflow-y: scroll; */
}

.m-content-heading {
    display: flex;
    padding: 20px;
    color: #FFFFFF;
}

.m-content-heading span {
    font-size: 14px;
    margin-right: 16px;
    display: flex;
    align-items: center;
}

.m-content-heading h2 {
    font-size: 22px;
    font-weight: 500;
    color: #FFF;
    margin: 0px 0px 0px 10px;
    padding: 0;
}

.m-subheading-wrapper {
    width: 100%;
    padding: 30px 20px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.m-subheading-wrapper p {
    color: rgba(255, 255, 255, 0.5);
    font-size: 16px;
}

.m-content-subheading {
    font-size: 26px;
    font-weight: 600;
    color: #FFF;
    padding: 0;
    margin: 0;
}

.m-content-subheading span {
    color: #FFFFFF80;
}

.m-content {
    padding: 20px;
    width: 100%;
}

.m-content h2 {
    font-size: 22px;
    font-weight: 500;
    color: #FFF;
    padding: 0;
    margin: 0;
}

.m-subject {
    display: flex;
    margin-top: 12px;
    justify-content: space-between;
}

.m-subject .m-subject-label {
    display: flex;
    align-items: center;
    flex: 2;
}

.m-subject span {
    display: flex;
    font-size: 16px;
    font-weight: 500;
    color: #FFFFFF80;
}

.m-buttons {
    width: 100%;
    padding: 20px;
}

.m-hr {
    width: 100%;
    border: 1px solid #FFFFFF10;
}

.m-content-div {
    width: 100%;
    padding: 0px 20px 20px 20px;
    display: flex;
}

.cv-btn {
    height: 78px;
    width: 80px;
    background-color: #15161F !important;
    border: 1px solid #242632 !important;
    border-radius: 4px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #FFFFFF;
    font-size: 10px;
    padding: 12px 20px;
    pointer-events: auto;
    margin-right: 10px;
}

.cv-btn svg {
    height: 30px !important;
    width: 30px !important;
    margin-bottom: 10px;
}
</style>